/**
 * Application entry point
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { config } from "./config";

// Start MSW only when VITE_ENABLE_MOCK_API=true
async function enableMocking() {
  if (!config.features.enableMockApi) {
    return;
  }

  const { worker } = await import("./test/mocks/browser");

  return worker.start({
    onUnhandledRequest: "bypass",
    serviceWorker: {
      url: "/mockServiceWorker.js",
    },
    quiet: false,
  });
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    'Root element not found. Make sure there is a div with id="root" in index.html',
  );
}

enableMocking().then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
